const YT_EMBED_BASE_LINK = "https://www.youtube.com/embed/"

const convertUrlToEmbedLink=(videoUrl)=>{
    if(!videoUrl) throw "Missing arg: videoUrl"
    else {
        var link
        var id
        if(videoUrl.includes("watch")){
            id = videoUrl.substring(videoUrl.search("v=") + 2)
        }else if(videoUrl.includes("youtu.be")){
            id = videoUrl.substring(videoUrl.lastIndexOf("/") + 1)
        }else if(videoUrl.includes("embed")){
            id = videoUrl.substring(videoUrl.lastIndexOf("/") + 1)
        }else throw "Invalid link format"
        return YT_EMBED_BASE_LINK + id
    }
}


export {convertUrlToEmbedLink} ; 



// WEBPACK FOOTER //
// ./src/third-party/youtube/utils/ytHelper.js